import {
  SlackUser,
  fromSlackWorkspace,
} from '../../../../domain/value-object/Slack/UserVO'
import { SlackWorkspace } from '../../../../domain/value-object/Slack/WorkspaceVO'
import { SingleSheetPropertyValueType } from '../model/singleSheetProperty'

export type SlackUserSelectionState = 'empty' | 'incomplete' | 'complete'

// ワークスペースだけ選ばれてユーザーが未選択の中間状態（incomplete）も、
// DATE_TERM等の期間系セルと同じくformModelへそのまま反映する（SlackUserCell参照）。
// この値は保存できないため、必須チェック（isRequiredValueMissing）と常時チェック
// （formValidation.tsのvalidateSlackUserCompleteness）の両方が弾く必要があり、
// 「選択完了」の定義が2箇所に分散して食い違わないようここに集約する。
export const getSlackUserSelectionState = (
  value: SingleSheetPropertyValueType
): SlackUserSelectionState => {
  if (typeof value !== 'object' || Array.isArray(value)) return 'empty'
  if (!('slackWorkspaceId' in value) || !value.slackWorkspaceId) return 'empty'
  if (!('slackUserId' in value) || !value.slackUserId) return 'incomplete'
  return 'complete'
}

// baselineValue（永続化済みの値）と同じワークスペースを選び直した場合は、それを
// そのまま採用して既存レコードのuuidを保つ。uuidを落とすとサーバ側で更新ではなく
// 新規登録になってしまう。永続化済みの値を基準にするため、A→B→Aと切り替えても
// Aのuuidを復元できる。
export const resolveWorkspaceSelection = (
  baselineValue: SlackUser | undefined,
  workspace: SlackWorkspace
): SlackUser =>
  baselineValue && baselineValue.slackWorkspaceId === workspace.slackWorkspaceId
    ? baselineValue
    : fromSlackWorkspace(workspace)
